export const firebaseConfig = {
	apiKey: "AIzaSyB345msJ06HEDsWzm9bE9D0WMS9c_MlTuE",
	authDomain: "myportfolio-add07.firebaseapp.com",
	databaseURL:
		"https://myportfolio-add07-default-rtdb.asia-southeast1.firebasedatabase.app",
	projectId: "myportfolio-add07",
	storageBucket: "myportfolio-add07.appspot.com",
	messagingSenderId: "1001586187765",
	appId: "1:1001586187765:web:96da8b8f85de866e1414bc",
	measurementId: "G-2M7JLCMXT7",
};
